import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeviceType } from '../../shared/enums/device-type.enum';
import { VoucherType } from '../../shared/enums/voucher-type.enum';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly HOME_BRAND = [
    'apple',
    'samsung',
    'huawei',
    'sony',
    'xiaomi',
    'lg',
    '小米',
    '蘋果',
    '三星',
    '華為',
  ];

  private readonly DEVICE_ISSUE_QUESTIONS = {
    mobile: [
      {
        title: 'Shell issue',
        options: [
          {
            key: 'scratched_shell',
            value: 'Scratched shell',
          },
          {
            key: 'bent',
            value: 'Bent',
          },
          {
            key: 'back_glass',
            value: 'Back Glass',
          },
        ],
      },
      {
        title: 'Monitor issue',
        options: [
          {
            key: 'scratched_monitor',
            value: 'Scratched Screen',
          },
          {
            key: 'glasses',
            value: 'Broken Glasses',
          },
          {
            key: 'residual_image',
            value: 'Color of LCD Display',
          },
          {
            key: 'touch_screen',
            value: 'Touch Screen',
          },
        ],
      },
      {
        title: 'Others issue',
        options: [
          {
            key: 'front_camera',
            value: 'Front Camera',
          },
          {
            key: 'mic_speaker',
            value: 'Dust',
          },
          {
            key: 'finger_print',
            value: 'Fingerprint+ Face ID',
          },
          {
            key: 'charging',
            value: 'Charging',
          },
          {
            key: 'repair_unit',
            value: 'Repair Unit',
          },
          {
            key: 'vibration',
            value: 'Vibration',
          },
          {
            key: 'stylus',
            value: 'Compass+Orientation',
          },
        ],
      },
    ],
    watch: [
      {
        title: 'Shell issue',
        options: [
          {
            key: 'scratched_shell',
            value: 'Scratched shell',
          },
          {
            key: 'bent',
            value: 'Bent',
          },
          {
            key: 'back_glass',
            value: 'Back Glass',
          },
        ],
      },
      {
        title: 'Monitor issue',
        options: [
          {
            key: 'scratched_monitor',
            value: 'Scratched Screen',
          },
          {
            key: 'glasses',
            value: 'Broken Glasses',
          },
          {
            key: 'residual_image',
            value: 'Color of LCD Display',
          },
          {
            key: 'touch_screen',
            value: 'Touch Screen',
          },
        ],
      },
      {
        title: 'Others issue',
        options: [
          {
            key: 'charging',
            value: 'Charging',
          },
          {
            key: 'repair_unit',
            value: 'Repair Unit',
          },
          {
            key: 'vibration',
            value: 'Vibration',
          },
          {
            key: 'pair',
            value: "Can't connect / pair another device",
          },
        ],
      },
    ],
    earbuds: [
      {
        title: 'Shell issue',
        options: [
          {
            key: 'scratched_shell',
            value: 'Scratched shell',
          },
        ],
      },
      {
        title: 'Others issue',
        options: [
          {
            key: 'charging',
            value: 'Charging',
          },
          {
            key: 'repair_unit',
            value: 'Repair Unit',
          },
          {
            key: 'pair',
            value: "Can't connect / pair another device",
          },
          {
            key: 'speaker',
            value: "Sound of left and/or right isn't functioning normally",
          },
        ],
      },
    ],
    notebook: [
      {
        title: 'Shell issue',
        options: [
          {
            key: 'scratched_shell',
            value: 'Scratched shell',
          },
          {
            key: 'damaged_shell',
            value: 'Broken shell',
          },
        ],
      },
      {
        title: 'Monitor issue',
        options: [
          {
            key: 'broken_monitor',
            value: 'Broken monitor',
          },
          {
            key: 'scratched_monitor',
            value: 'Scratched Monitor',
          },
        ],
      },
      {
        title: 'Others issue',
        options: [
          {
            key: 'keyboard',
            value: 'Keyboard is not functioning properly',
          },
          {
            key: 'touch_pad',
            value: 'Touchpad is not functioning properly',
          },
          {
            key: 'power',
            value: 'Not functioning properly / unable to turn on',
          },
          {
            key: 'original_dc_adapter',
            value: 'No original charger and adapter',
          },
          {
            key: 'parallel_imports',
            value: 'Non-HK version',
          },
          {
            key: 'battery',
            value: 'Fail to bootup by Battery only',
          },
        ],
      },
    ],
  };

  public voucherTypesEnum = VoucherType;

  static gaTrackingID = '';

  configs: any;

  constructor(private http?: HttpClient) {
    this.loadConfig();
  }

  /**
   * Loading config
   *
   * @returns
   * @memberof ConfigService
   */
  async loadConfig() {
    try {
      const data = await this.http.get('./assets/config.json').toPromise();
      this.configs = data;
      ConfigService.gaTrackingID = this.configs['GA_TRACKING_ID'];
      return this.configs;
    } catch (error) {
      const { message } = error;
      document.write(message);
      return false;
    }
  }

  get homeBrandConfig() {
    return this.HOME_BRAND || [];
  }

  async getDeviceIssueQuestions() {
    return [
      ...this.DEVICE_ISSUE_QUESTIONS[
        DeviceType[localStorage.getItem('deviceType') + '']
      ],
    ];
  }

  get notebookTestCase() {
    return [...this.DEVICE_ISSUE_QUESTIONS.notebook];
  }

  /**
   * Get active theme
   *
   * @readonly
   * @memberof ConfigService
   */
  get activeTheme() {
    return this.configs['THEME'] || 'fortress';
  }

  get isMrrWebTheme() {
    return this.activeTheme === 'mrrweb';
  }

  // Get voucher type by theme
  get voucherTypes() {
    return [VoucherType['FPS'], VoucherType['Bank transfer']];
  }

  get deviceTypeEnabled() {
    return this.configs['ENABLE_DEVICE_TYPE'] || [];
  }

  /**
   * Get current site locale
   *
   * @readonly
   * @memberof ConfigService
   */
  get currentLocale() {
    return localStorage.getItem('locale') || 'zh';
  }
}
